import type {UnfairPriceLocationState, UnfairPriceStoreState} from './types';

import {Loading} from '@ds/components';
import {PageLayout} from '@ds/layout';
import Empty from 'common/empty/Empty';
import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import {useAppDispatch, useAppSelector} from 'store';
import {getProductsPriceTracking} from 'store/slices/chortke/thunk';
import {getSelectedVendorFromStorage} from 'utils/Helper';

import UnfairPriceProductCard from './components/UnfairPriceProductCard/UnfairPriceProductCard';

const UnfairPrice: React.FC = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const locationState = (location.state ?? {}) as UnfairPriceLocationState;
  const selectedVendor = useAppSelector((state) => state.dashboard.selectedVendor);
  const storedVendor = getSelectedVendorFromStorage();
  const storedVendorId =
    typeof storedVendor?.id === 'string' || typeof storedVendor?.id === 'number'
      ? storedVendor.id
      : undefined;
  const vendorId = locationState.vendorId ?? selectedVendor?.id ?? storedVendorId;
  const chortkeState = useAppSelector((state) => state.chortke) as UnfairPriceStoreState;
  const loading = chortkeState.loading;
  const productsPriceTracking = Array.isArray(chortkeState.productsPriceTracking)
    ? chortkeState.productsPriceTracking
    : [];

  useEffect(() => {
    if (vendorId) {
      void dispatch(getProductsPriceTracking({vendorId}));
    }
  }, [dispatch, vendorId]);

  return (
    <PageLayout
      header={
        <p className="border-b border-gray-02 px-4 py-4 text-body-sm text-gray-08">
          قیمت این کالاها با قیمت مرجع اختلاف معناداری دارند و باعث کاهش فروش شما می‌شوند. قیمت مرجع
          قیمتی است که اکثریت فروشندگان منطقه شما تعیین کرده‌اند.
        </p>
      }
      contentClassName="bg-gray-02 p-3"
    >
      {loading > 0 && productsPriceTracking.length === 0 ? (
        <div className="flex min-h-60 flex-1 items-center justify-center">
          <Loading size="large" color="primary" />
        </div>
      ) : productsPriceTracking.length === 0 ? (
        <Empty className="min-h-60 flex-1">
          <span className="text-body-sm text-gray-08">کالایی با قیمت غیرمنصفانه یافت نشد</span>
        </Empty>
      ) : (
        <div className="flex flex-col gap-2">
          {productsPriceTracking.map((product) => (
            <UnfairPriceProductCard key={product.id} product={product} />
          ))}
        </div>
      )}
    </PageLayout>
  );
};

export default UnfairPrice;
